<template>
  <div class="fin-state" :class="`fin-state--${kind}`" :role="kind === 'error' ? 'alert' : 'status'" :aria-busy="kind === 'loading' ? 'true' : null">
    <template v-if="kind === 'loading'">
      <div class="ui-card fin-skel-hero">
        <span class="ui-sk" style="width: 38%; height: 12px"></span>
        <span class="ui-sk" style="width: 64%; height: 44px"></span>
        <span class="ui-sk" style="width: 50%; height: 12px"></span>
      </div>
      <div v-if="!lines" class="ui-kpis">
        <div v-for="n in 4" :key="n" class="ui-kpi">
          <span class="ui-sk" style="width: 50%; height: 11px"></span>
          <span class="ui-sk" style="width: 72%; height: 22px"></span>
        </div>
      </div>
      <div v-for="n in lines" :key="`l${n}`" class="ui-card fin-skel-line">
        <span class="ui-sk" style="width: 30%; height: 14px"></span>
        <span class="ui-sk" style="width: 70%; height: 11px"></span>
      </div>
    </template>
    <div v-else class="ui-card">
      <div class="ui-empty">
        <span class="ui-empty__icon"><v-icon size="22">{{ icon }}</v-icon></span>
        <b>{{ title }}</b>
        <span v-if="text">{{ text }}</span>
        <div class="ui-empty__actions"><slot></slot></div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Stanja ekrana: učitavanje (skelet), greška, prazno. Jedna komponenta da svi ekrani izgledaju isto.
 * kind: loading | error | empty; za error i empty dugme se daje kroz slot.
 */
export default {
  name: "FinanceState",
  props: {
    kind: { type: String, default: "empty" },
    icon: { type: String, default: "mdi-tray-full" },
    title: { type: String, default: "" },
    text: { type: String, default: "" },
    /** broj redova skeleta umjesto kartica (liste) */
    lines: { type: Number, default: 0 },
  },
};
</script>
